import EnumSet from 'Services/enumSet'

export interface IVerificationTypeTwoFactorAuth extends EnumSet {
  none: string
  whatsapp: string
  sms: string
  email: string
}

const verificationTypeTwoFactorAuth = new EnumSet({
  none: { value: 0, description: 'Nenhum' },
  whatsapp: { value: 1, description: 'WhatsApp' },
  sms: { value: 2, description: 'SMS' },
  email: { value: 3, description: 'Email' },
}) as IVerificationTypeTwoFactorAuth

export const getStatusDescriptionName = (value: number): string => ({
  [verificationTypeTwoFactorAuth.none]: 'Nenhum',
  [verificationTypeTwoFactorAuth.whatsapp]: 'WhatsApp',
  [verificationTypeTwoFactorAuth.sms]: 'SMS',
  [verificationTypeTwoFactorAuth.email]: 'Email',
}[value])

export default verificationTypeTwoFactorAuth